import Vue from "vue";
import Router from "vue-router";
import { Message } from "element-ui";
import { getCurrentUser } from "../api/auth";
import adminStore from "../store/admin";
import { hasPermission } from "../config/navigation";
import Login from "../views/Login.vue";
import AdminLayout from "../layout/AdminLayout.vue";
const Dashboard = () => import("../views/Dashboard.vue");
const HomeContent = () => import("../views/HomeContent.vue");
const FeaturedManage = () => import("../views/FeaturedManage.vue");
const AssetsManage = () => import("../views/AssetsManage.vue");
const RoutesManage = () => import("../views/RoutesManage.vue");
const RoutePlansManage = () => import("../views/RoutePlansManage.vue");
const InspirationItemsManage = () => import("../views/InspirationItemsManage.vue");
const ScenicSpotsManage = () => import("../views/ScenicSpotsManage.vue");
const ScenicMapPointsManage = () => import("../views/ScenicMapPointsManage.vue");
const HotelsManage = () => import("../views/HotelsManage.vue");
const FoodsManage = () => import("../views/FoodsManage.vue");
const CultureExperiencesManage = () => import("../views/CultureExperiencesManage.vue");
const BasicServiceManage = () => import("../views/BasicServiceManage.vue");
const CustomServiceManage = () => import("../views/CustomServiceManage.vue");
const ServiceNeedOptionsManage = () => import("../views/ServiceNeedOptionsManage.vue");
const ConsultationsManage = () => import("../views/ConsultationsManage.vue");
const BusinessRecordsManage = () => import("../views/BusinessRecordsManage.vue");
const BusinessRecordCreate = () => import("../views/BusinessRecordCreate.vue");
const BusinessRecordDetail = () => import("../views/BusinessRecordDetail.vue");
const PaymentsManage = () => import("../views/PaymentsManage.vue");
const ReviewsManage = () => import("../views/ReviewsManage.vue");
const UsersManage = () => import("../views/UsersManage.vue");
const RolesManage = () => import("../views/RolesManage.vue");
const StaffManage = () => import("../views/StaffManage.vue");
const SettingsManage = () => import("../views/SettingsPage.vue");
const AgreementVersionsManage = () => import("../views/AgreementVersionsManage.vue");
const RecommendersManage = () => import("../views/RecommendersManage.vue");
const TabbedPage = () => import("../views/TabbedPage.vue");

Vue.use(Router);

const router = new Router({
  mode: "hash",
  routes: [
    {
      path: "/login",
      name: "login",
      component: Login,
      meta: { public: true, title: "登录" }
    },
    {
      path: "/",
      component: AdminLayout,
      redirect: "/dashboard",
      children: [
        { path: "dashboard", name: "dashboard", component: Dashboard, meta: { title: "工作台" } },
        { path: "content/assets", name: "assets-manage", component: AssetsManage, meta: { modules: ["assets"], title: "图片素材库" } },
        { path: "content/featured", name: "featured-manage", component: FeaturedManage, meta: { modules: ["routes", "settings"], title: "精选行程" } },
        { path: "content/home", name: "home-content", component: HomeContent, meta: { modules: ["home-configs"], title: "首页与登录页" } },
        { path: "content/routes", name: "routes-manage", component: RoutesManage, meta: { modules: ["routes"], title: "线路产品" } },
        { path: "content/route-plans", name: "route-plans-manage", component: RoutePlansManage, meta: { modules: ["route-plans"], title: "方案模板" } },
        { path: "inspirations", name: "inspirations-manage", component: InspirationItemsManage, meta: { modules: ["inspiration-items"], title: "灵感探索" } },
        { path: "content/scenic", name: "scenic-manage", component: TabbedPage, props: { tabs: [
          { name: "spots", label: "景点管理", component: ScenicSpotsManage, modules: ["scenic-spots"] },
          { name: "map", label: "地图点位", component: ScenicMapPointsManage, modules: ["scenic-map-points"] }
        ] }, meta: { modules: ["scenic-spots", "scenic-map-points"], title: "景点与地图" } },
        { path: "content/scenic-spots", redirect: { path: "/content/scenic", query: { tab: "spots" } } },
        { path: "content/scenic-map", redirect: { path: "/content/scenic", query: { tab: "map" } } },
        { path: "content/hotels", name: "hotels-manage", component: HotelsManage, meta: { modules: ["hotels"], title: "酒店管理" } },
        { path: "content/foods", name: "foods-manage", component: FoodsManage, meta: { modules: ["food-items"], title: "美食推荐" } },
        { path: "content/culture", name: "culture-experiences-manage", component: CultureExperiencesManage, meta: { modules: ["culture-experiences"], title: "文化体验" } },
        { path: "content/services", name: "services-manage", component: TabbedPage, props: { tabs: [
          { name: "basic", label: "基础服务介绍", component: BasicServiceManage, modules: ["basic-service-config"] },
          { name: "custom", label: "定制服务介绍", component: CustomServiceManage, modules: ["custom-service-config"] },
          { name: "options", label: "服务选项", component: ServiceNeedOptionsManage, modules: ["service-need-options"] }
        ] }, meta: { modules: ["basic-service-config", "custom-service-config", "service-need-options"], title: "服务介绍" } },
        { path: "content/basic-service", redirect: { path: "/content/services", query: { tab: "basic" } } },
        { path: "content/custom-service", redirect: { path: "/content/services", query: { tab: "custom" } } },
        { path: "content/service-options", redirect: { path: "/content/services", query: { tab: "options" } } },
        { path: "business/consultations", name: "consultations-manage", component: ConsultationsManage, meta: { modules: ["consultations"], title: "咨询接待" } },
        { path: "business/records", name: "business-records-manage", component: BusinessRecordsManage, meta: { modules: ["custom-demands", "service-orders", "consult-orders"], title: "需求与订单" } },
        { path: "business/records/create", name: "business-record-create", component: BusinessRecordCreate, meta: { modules: ["service-orders"], title: "录入旅游订单", activeMenu: "/business/records" } },
        { path: "business/records/:recordKey", name: "business-record-detail", component: BusinessRecordDetail, meta: { modules: ["custom-demands", "service-orders", "consult-orders"], title: "处理需求与订单", activeMenu: "/business/records" } },
        { path: "business/custom-demands", name: "custom-demands-manage", redirect: (to) => ({ path: "/business/records", query: to.query }) },
        { path: "business/service-orders", name: "service-orders-manage", redirect: (to) => ({ path: "/business/records", query: to.query }) },
        { path: "business/payments", name: "payments-manage", component: PaymentsManage, meta: { modules: ["payments"], title: "支付记录" } },
        { path: "business/reviews", name: "reviews-manage", component: ReviewsManage, meta: { modules: ["reviews"], title: "评价审核" } },
        { path: "customers/users", name: "users-manage", component: UsersManage, meta: { modules: ["users"], title: "客户管理" } },
        { path: "business/recommenders", name: "recommenders-manage", component: TabbedPage, props: { tabs: [
          { name: "list", label: "推荐官管理", component: RecommendersManage, modules: ["recommenders"] },
          { name: "rules", label: "推荐官规则", component: SettingsManage, props: { section: "referral" }, modules: ["settings"] }
        ] }, meta: { modules: ["recommenders", "settings"], title: "推荐官" } },
        { path: "system/roles", name: "roles-manage", component: RolesManage, meta: { modules: ["roles"], title: "角色与菜单权限" } },
        { path: "team/staff", name: "staff-manage", component: StaffManage, meta: { modules: ["staff"], title: "员工账号" } },
        { path: "content/about", name: "about-content", component: SettingsManage, props: { section: "content" }, meta: { modules: ["settings"], title: "关于我们与页面图片" } },
        { path: "business/referral-settings", redirect: { path: "/business/recommenders", query: { tab: "rules" } } },
        { path: "system/settings", name: "settings-manage", component: SettingsManage, meta: { modules: ["settings"], title: "系统参数" } },
        { path: "system/proposal", name: "proposal-settings", component: SettingsManage, props: { section: "proposal" }, meta: { modules: ["settings"], title: "定制方案配置" } },
        { path: "system/agreements", name: "agreement-versions-manage", component: AgreementVersionsManage, meta: { modules: ["agreement-versions"], title: "协议管理" } },
        { path: "manage/home", redirect: "/content/home" },
        { path: "manage/routes", redirect: "/content/routes" },
        { path: "manage/routePlans", redirect: "/content/route-plans" },
        { path: "manage/scenic", redirect: "/content/scenic" },
        { path: "manage/scenicMap", redirect: { path: "/content/scenic", query: { tab: "map" } } },
        { path: "manage/hotels", redirect: "/content/hotels" },
        { path: "manage/foods", redirect: "/content/foods" },
        { path: "manage/culture", redirect: "/content/culture" },
        { path: "manage/services", redirect: "/content/services" },
        { path: "manage/onlineConsults", redirect: "/business/consultations" },
        { path: "manage/customDemands", redirect: "/business/records" },
        { path: "manage/routeDemands", redirect: "/business/records" },
        { path: "manage/serviceOrders", redirect: "/business/records" },
        { path: "manage/payments", redirect: "/business/payments" },
        { path: "manage/reviews", redirect: "/business/reviews" },
        { path: "manage/users", redirect: "/customers/users" },
        { path: "manage/recommenders", redirect: "/business/recommenders" },
        { path: "manage/staff", redirect: "/team/staff" },
        { path: "manage/settings", redirect: "/system/settings" }
      ]
    },
    { path: "*", redirect: "/dashboard" }
  ]
});

router.beforeEach(async (to, from, next) => {
  const token = window.localStorage.getItem("admin_token");
  if (to.meta.public) {
    next();
    return;
  }
  if (!token) {
    next({ path: "/login", query: { redirect: to.fullPath } });
    return;
  }
  try {
    const res = await getCurrentUser();
    adminStore.setAdmin(res.data.user);
  } catch (error) {
    if (error.response && error.response.status === 401) next({path:"/login",query:{redirect:to.fullPath}});
    else next(false);
    return;
  }
  const modules = to.matched.reduce((list, record) => list.concat((record.meta && record.meta.modules) || []), []);
  if (modules.length && !modules.some(moduleName => hasPermission(adminStore.admin, moduleName))) {
    Message({ type: "warning", message: "无权访问该页面", showClose: true, duration: 3000 });
    next(to.path === "/dashboard" ? false : "/dashboard");
    return;
  }
  next();
});

export default router;
